import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setReceiptModal } from '../actions/modalActions'
import { getObjectItem, getTranslation } from '../../actions/dataActions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import ReceiptLine from '../../components/ReceiptLine'
import Ink from 'react-ink';
import * as types from '../../constants/Types'
import * as resource from '../../constants/Resources'

class ReceiptModal extends Component {
    constructor(props) {
        super(props);
        this.closeWindow = this.closeWindow.bind(this);
    }

    closeWindow() {
        this.props.setReceiptModal(false);
    }

    render() {
        const titleItems = [];
        if (this.props.receipt.receiptnumber) {
            titleItems.push(`#${this.props.receipt.receiptnumber}`);
        }
        if (this.props.receipt.objectitemid) {
            const objectItem = this.props.getObjectItem(this.props.receipt.objectitemid);
            if (objectItem !== null) {
                titleItems.push(`${objectItem.ItemNumber}`);
            }
        }
        if (this.props.receipt.objectitemname && this.props.receipt.objectitemname !== '') {
            titleItems.push(`${this.props.receipt.objectitemname}`);
        }
        else if (this.props.receipt.objectitemdescription) {
            titleItems.push(`${this.props.receipt.objectitemdescription}`);
        }

        let title = '';
        titleItems.map(item => {
            if (title !== '') {
                title = `${title} - `;
            }
            title = `${title}${item}`;

            return '';
        })

        const lines = [];

        let subTotal = 0;
        this.props.receipt.lines.map(rec => {
            lines.push(rec);
            if (rec.linetype !== types.SUBTOTAL_LINE) {
                subTotal += rec.price;
            }
            return subTotal;
        })

        return (
            <Modal className='receiptModal'
                contentLabel=""
                isOpen={this.props.receiptModal.show}
                style={properties.receiptModalStyle}
                >
                <div className="receiptModal_header">
                    <div className="header_top">
                        {title}
                        <button className="header_close" onClick={this.closeWindow}>
                            <i className="icon remove" />
                            <Ink />
                        </button>
                    </div>

                </div>
                <div className="receiptModal_lines">
                    <div id="receipt" className="receiptModal_scrollable lines">
                        {lines.map(rec =>
                            <ReceiptLine
                                key={rec.id}
                                lineid={rec.id}
                                itemid={rec.itemid}
                                description={rec.text}
                                configuration={rec.configuration}
                                quantity={rec.quantity}
                                price={rec.price}
                                linetype={rec.linetype}
                                editable={rec.editable}
                                selected={rec.selected}
                                detailView={true}
                                discount={rec.discount}
                                simpleSeparator={rec.simpleSeparator}
                                />
                        )}
                    </div>
                </div>
                <div className="receiptModal_subTotal">
                    <div className="subTotal">
                        {this.props.getTranslation(resource.SUB_TOTAL)}
                    </div>
                    <div className="price">
                        {subTotal.toFixed(2).replace('.', ',')}
                    </div>
                </div>
            </Modal>
        )
    }
}

ReceiptModal.propTypes = {
}

function mapStateToProps(state) {
    return {
        receiptModal: state.modalState.receiptModal,
        receipt: state.receiptState.receipt
    }
}

export default connect(mapStateToProps, { setReceiptModal, getObjectItem, getTranslation })(ReceiptModal)


// WEBPACK FOOTER //
// src/modal/components/ReceiptModal.jsx